import React, { FC, useMemo } from 'react';
import {
  Controller,
  FieldValues,
  UseFormSetValue,
  RefCallBack,
} from 'react-hook-form';
import styled from 'styled-components';
import { Select } from 'components/atoms/select';
import {
  FormItemWrapper,
  FormItemDesc,
  FormItemLabel,
  FieldsErrorRenderer,
  FormFieldProps,
} from './form-elements';

const StyledSelect = styled(Select)`
  margin-top: var(--spacing-03);
  /* z-index: var(--zindex-elevated); */
`;

const SelectFieldRenderer = ({
  questionId,
  disabled,
  options,
  ref,
  setValue,
  value,
}: {
  questionId: string;
  disabled: boolean;
  options: {
    label: string;
    value: number;
    color: string | undefined;
  }[];
  ref: RefCallBack;
  setValue?: UseFormSetValue<FieldValues>;
  value: number;
}) => {
  const selectedValue = useMemo(() => {
    return value ? options.find((option) => option.value === value) : [];
  }, [value, options]);

  return (
    <StyledSelect
      type="tag"
      ref={ref}
      options={options}
      isDisabled={disabled}
      value={selectedValue}
      isClearable
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 'var(--zindex-popover-low)',
        }),
        menu: (base) => ({
          ...base,
          marginTop: 0,
        }),
      }}
      onChange={(v) => {
        setValue?.(questionId, v ? v.value : undefined);
      }}
    />
  );
};

export const DropdownChoiceField: FC<FormFieldProps> = ({
  field,
  control,
  setValue,
  errors,
  disabled,
}) => {
  return (
    <FormItemWrapper>
      <FormItemLabel label={field.questionText} required={field.required} />
      <Controller
        control={control}
        rules={{ required: field.required }}
        name={field.questionId.toString()}
        shouldUnregister
        render={(props) => (
          <SelectFieldRenderer
            ref={props.field.ref}
            value={props.field.value}
            questionId={field.questionId.toString()}
            disabled={disabled}
            setValue={setValue}
            options={(field.options || []).map((option) => {
              return {
                label: option.optionLabel,
                value: option.optionId,
                color: option.color,
              };
            })}
          />
        )}
      />

      <FieldsErrorRenderer errors={errors} questionId={field.questionId} />
      <FormItemDesc label={field.description} />
    </FormItemWrapper>
  );
};
